import { Button, ButtonProps } from "../components/Button";
import { Deco } from "../components/Deco";
import { Figure, FigureProps } from "../components/Figure";
import { Grid } from "../layouts/Grid";
import { MaxWidth } from "../layouts/MaxWidth";
import { Spacing } from "../layouts/Spacing";
import styles from "./Hero.module.css";

export type HeroProps = {
  pretitle: string;
  title: string;
  text?: string;
  button?: ButtonProps;
  image: FigureProps["image"];
};

export const Hero = ({ pretitle, title, text, button, image }: HeroProps) => {
  if (!title) return null;
  return (
    <header className={styles.header}>
      <Spacing size="sm">
        <MaxWidth>
          <Grid layout="split">
            <div className="text">
              <span className={styles.preTitle}>
                <Deco deco="underline-yellow">{pretitle}</Deco>
              </span>
              <h1 className={styles.title}>{title}</h1>
              {text && <p className={styles.text}>{text}</p>}
              {button && (
                <Button
                  {...button}
                  variation="primary"
                  className={styles.button}
                />
              )}
            </div>
            <div>
              <Figure
                image={image}
                width={800}
                height={800}
                className={styles.image}
              />
            </div>
          </Grid>
        </MaxWidth>
      </Spacing>
    </header>
  );
};
